import React from 'react';
import { useTranslation } from 'react-i18next';

import FeaturedDownload from '../../../assets/icons/featured_download.svg';
import { EventActions, EventNames } from '../../../shared/constants/analytics';
import useTracking from '../../../utilities/hooks/useTracking';

export interface DownloadInfoCardProps {
  title: string;
  subTitle: string;
  link: string;
  color: string;
  event: string;
}

function DownloadInfoCard({
  title,
  subTitle,
  link,
  color,
  event,
}: DownloadInfoCardProps) {
  const { t } = useTranslation();
  const { trackEvent } = useTracking();

  return (
    <div
      className="flex w-full items-center justify-between rounded-lg px-4 py-5"
      style={{ backgroundColor: color }}
    >
      <div className="flex flex-col text-sm">
        <div className="font-semibold text-black">{t(title)}</div>
        <div className="text-black-700">{t(subTitle)}</div>
      </div>
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        onClick={() => {
          trackEvent(EventNames.WellBeingDashboard, {
            eventLabel: event,
            eventCategory: event,
            eventAction: EventActions.click,
            eventValue: 'dimensions',
            eventSource: 'home_page',
          });
        }}
      >
        <div className="flex h-12 w-12 items-center justify-center">
          <img src={FeaturedDownload} alt="download" className="h-6 w-6" />
        </div>
      </a>
    </div>
  );
}

export default DownloadInfoCard;
